import React from 'react'
import { Pipeline } from '@morningtrain/react-helpers'
import { Link, TriggerPipelineOnNavigate } from '@morningtrain/react-navigation'
import { MountSmartviewWithModelOnPipe } from '@morningtrain/react-smartviews'
import ManageRolesSmartview from './smartviews/ManageRolesSmartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui/index'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { ModelWithForm, WhenModel } from '@morningtrain/react-resources'
import InnerRolePermissions from 'pages/app/settings/permissions/partials/InnerRolePermissions'
import SelectedRolePermissions from 'pages/app/settings/permissions/partials/SelectedRolePermissions'

export default function PermissionsForRole () {
  return (
    <>

      <Pipeline>
        <TriggerPipelineOnNavigate />
        <MountSmartviewWithModelOnPipe smartview={<ManageRolesSmartview />} replace />
      </Pipeline>

      <Translator namespace='settings.permissions'>

        <ModelWithForm resourceName='permissions.roles'>
          <WhenModel>
            <SelectedRolePermissions />

            <UI.BackButton>
              <Link route='app.settings.permissions'>
                <Translation name='actions.back_to_permissions' />
              </Link>
            </UI.BackButton>

            <UI.PageHeader title={(
              <UI.WithSubtitle subtitle={<Translation name='description' />}>
                <TranslatedTitle name='title_with_role' data={{ role: 'model:translated_name' }} />
              </UI.WithSubtitle>
                        )}
            >
              <UI.ButtonWrap>
                <UI.SubmitButton>
                  <Translation name='actions.save_permissions' />
                </UI.SubmitButton>
              </UI.ButtonWrap>
            </UI.PageHeader>

            <InnerRolePermissions />
          </WhenModel>
        </ModelWithForm>

      </Translator>
    </>
  )
}
